import { UserTaskService } from './../../../data/services/user-task'
import { UserTask } from './../../../data/models/user-task'
import { UserTaskPresenter } from './../../../data/presenters/user-task'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { AppContext } from '../../..'

export const UserTaskConfig: IDataServiceConfig<UserTask> = {
  service: UserTaskService,
  deps: [ModelRepository, AppContext],
  endpoint: 'lms/user_tasks?filter[user-id]=:user_id&fields[tasks]=id',
  model: UserTask,
  presenter: UserTaskPresenter,
  backend: 'cached',
  mappings: [
    {
      classType: 'UserTask',
      jsonType: 'user-tasks',
      propertyMapping: {
        flagged: {
          mapsTo: 'flag-state'
        },
        updatedAt: {
          mapsTo: 'updated-at',
          transform: {
            toModel: (dateString) => typeof dateString !== 'undefined' ? new Date(dateString) : null
          }
        }
      }
    },
    {
      classType: 'Task',
      jsonType: 'tasks',
      propertyMapping: {
        tasks: {
          type: 'Task',
          isCollection: true
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/user-task.config.ts